import {Injectable} from '@angular/core';
import {EntityAssetTransactionListDto} from '@dto/holdings/entity-asset-transaction-list.dto';
import {EntityAssetTransactionViewModel} from '../view-models/entity-asset-transaction.view-model';
import {EntityAssetTransactionDto} from '@dto/holdings/entity-asset-transaction.dto';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';

@Injectable({
  providedIn: 'root'
})
export class EntityAssetTransactionConverterService {

  public convert(transactionList: EntityAssetTransactionListDto): EntityAssetTransactionViewModel[] {
    const transactions = transactionList.entityAssetTransactions;
    const lowestId = Math.min(...transactions.map(transaction => transaction.id));
    return transactions.map(transaction => this.convertSingle(transaction, lowestId));
  }

  private convertSingle(transaction: EntityAssetTransactionDto, lowestId: number): EntityAssetTransactionViewModel {
    const offsetId = transaction.id - lowestId; // Offset the numeric transaction ID by the lowest ID in this set of transactions
    const transactionDate = new Date(transaction.date);
    const offsetDate = new Date(transactionDate.getTime() + offsetId); // Add the transaction's offset ID as milliseconds to differentiate this transaction from others made on the same day

    return {
      date: offsetDate,
      type: transaction.type,
      description: transaction.description,
      amount: new FormattedNumber(transaction.amount),
    };
  }
}
